import { SorXMetadata } from "datatypes/SorXFormat";
import { Point3 } from "libraries/DataTypes/Point3";

export class IndustrialCamIV64MockMeasurements {
    static readonly leakInspection: SorXMetadata = {
        dateTime: "2025-08-25T10:14:28+02:00",
        estimatedDistance: 2.0,
        estimatedDistanceUnit: "meter",
        firmwareRelease: "develop-1.159.1-1580-549 (L642v+-industrial (dev))",
        frequencySelectionFrom: 25159.263671875,
        frequencySelectionFromUnit: "Hz",
        frequencySelectionTo: 29980.19921875,
        frequencySelectionToUnit: "Hz",
        ldMetadata: {
            results: {
                cost: 43.32004928588867,
                costUnit: "EUR",
                electricityUsage: 0.007218805141746998,
                electricityUsageUnit: "kW / year",
                isLeakRateAccurate: [true],
                rate: [0.7218804955482483, 0.8478094935417175, 0.8542903661727905, 0.8735536336898804],
                rateUnit: "l/min",
                reasonInaccurate: "NA",
                type: "HoseSlitCutLeak",
                unitSystem: "metric",
            },
            settings: {
                electricityCost: 1.0,
                electricityCostUnit: "EUR / kWh",
                gasCost: 1.0,
                gasCostUnit: "EUR / 1000L",
                gasType: "other",
                linePressureUnit: "Pa",
                linePressureValue: 1.0,
                operatingHoursPerYear: 1,
                powerRatio: 1.0,
                powerRatioUnit: "kW / 100L / minute",
                unitSystem: "metric",
            },
        },
        notes: "This is a note",
        sampleRate: 109375,
        sampleRateUnit: "Hz",
        snrValue: [40.452552795410156, 38.040748596191406, 41.22664260864258, 37.241233825683594],
        splAtSource: [33.41162872314453, 31.163768768310547, 31.01041030883789, 30.71356964111328],
        splAtSourceUnit: "dBSPL",
        tags: {
            assetID: "",
            assetName: "",
            assetStatus: "undetermined",
            assetType: "",
        },
        targetPointDistance: 2.0,
        targetPointDistanceUnit: "meter",
        type: "leakDetection",
        version: 1,
    };

    static readonly partialDischargeInspection = {
        dateTime: "2025-11-21T13:29:59+00:00",
        estimatedDistance: 2.0,
        estimatedDistanceUnit: "meter",
        firmwareRelease: "2025-q4-28-10-2784 (L642v+-industrial (dev))",
        frequencySelectionFrom: 8000.0,
        frequencySelectionFromUnit: "Hz",
        frequencySelectionTo: 13000.0,
        frequencySelectionToUnit: "Hz",
        notes: "",
        pdMetadata: {
            results: {
                externalPercentage: 100,
                internalPercentage: 0,
                nonePercentage: 0,
                trackingPercentage: 0,
            },
            settings: {
                operatingConditions: "AC50Hz",
            },
        },
        sampleRate: 109375,
        sampleRateUnit: "Hz",
        snrValue: 43.18557357788086,
        splAtSource: 49.135406494140625,
        splAtSourceUnit: "dBSPL",
        tags: {
            assetID: "",
            assetName: "",
            assetStatus: "undetermined",
            assetType: "",
        },
        targetPointDistance: 2.0,
        targetPointDistanceUnit: "meter",
        type: "partialDischarge",
        version: 1,
    };

    static readonly oldLeakInspection = {
        dateTime: "2025-06-16T18:47:32Z",
        estimatedDistance: 0.32366669178009033,
        estimatedDistanceUnit: "meter",
        firmwareRelease: "2.18.2-iv64ex-387",
        frequencySelectionFrom: 164.3401641845703,
        frequencySelectionFromUnit: "Hz",
        frequencySelectionTo: 14899.3740234375,
        frequencySelectionToUnit: "Hz",
        ldMetadata: {
            results: {
                cost: 999,
                costUnit: "EUR",
                electricityUsage: 999,
                // Note this is wrong, should be kWh / year, but device currently returns kW / year
                // (we deal with this when parsing in SorXMeasurement.ts)
                electricityUsageUnit: "kW / year", //
                isLeakRateAccurate: [true, false, false],
                rate: [3, 0.0, 0.0, 0.0], // Take the first value as leak rate
                rateUnit: "l/min",
                reasonInaccurate: "NA",
                type: "ThreadedEndCap",
                unitSystem: "unknown",
            },
            settings: {
                electricityCost: 0.45,
                // Note this is wrong, should be EUR / kWh, but device currently returns as such
                // (we deal with this when parsing in SorXMeasurement.ts)
                electricityCostUnit: "kWh",
                gasCost: 0.1,
                gasCostUnit: "EUR / liter",
                gasType: "naturalGas",
                linePressureUnit: "Pa",
                linePressureValue: 10000,
                operatingHoursPerYear: 7200,
                powerRatio: 58,
                powerRatioUnit: "kW / 100L/ minute",
                unitSystem: "metric",
            },
        },
        notes: "This is leak inspection note\n\n",
        sampleRate: [125000, 62500, 31250, 0],
        sampleRateUnit: "Hz",
        snrValue: [8.0, 6.0, 4.0, 0.0],
        splAtSource: 29.468820571899414,
        splAtSourceUnit: "dBSPL",
        tags: { assetID: "Id", assetName: "Name", assetStatus: "found", assetType: "Type not known" },
        targetPointDistance: 2.0,
        targetPointDistanceUnit: "meter",
        type: "leakDetection",
        sourceLocation: [
            {
                x: 0.0,
                y: 0.0,
                z: 0.0,
            },
        ] as Point3[],
        version: 0,
    } as SorXMetadata;

    static readonly oldPartialDischargeInspection = {
        dateTime: "2025-06-16T18:49:12Z",
        estimatedDistance: 0.32095998525619507,
        estimatedDistanceUnit: "meter",
        firmwareRelease: "2.18.2-iv64ex-387",
        frequencySelectionFrom: 164.3401641845703,
        frequencySelectionFromUnit: "Hz",
        frequencySelectionTo: 14899.3740234375,
        frequencySelectionToUnit: "Hz",
        notes: "Partial discharge",
        pdMetadata: {
            results: {
                externalPercentage: 60,
                internalPercentage: 40,
                nonePercentage: 0,
                trackingPercentage: 0,
            },
            settings: { operatingConditions: "AC50Hz" },
        },
        sampleRate: 125000,
        sampleRateUnit: "Hz",
        splAtSource: [21.19965934753418, 0.0, 0.0],
        splAtSourceUnit: "dBSPL",
        tags: { assetID: "Id", assetName: "Name", assetStatus: "found", assetType: "Type not known" },
        targetPointDistance: 2.0,
        targetPointDistanceUnit: "meter",
        type: "partialDischarge",
        version: 0,
    } as SorXMetadata;
}
